define('components/decorators/dropdown-footer',[
    'jquery'
], function($) {

    $.extend(companyInfo.decorators, {

        'dropdown-footer': function() {
            var field = $(this);
            var dropdown = field.data('select2').dropdown;
            var text = $(this).attr("data-dropdown-footer-text");
            var dropdownFooter = $("<button><i class='ico ico-search ico-single'></i>" + text + "</button>").addClass('button select2-footer');
            dropdownFooter.on('click', function () {
                field.blur();
            });
            dropdown.append(dropdownFooter);

            $(this).on("select2-selecting", function (e) {
                dropdownFooter.addClass("select2-footer--visible");
            });
        }

    });

});

